document.addEventListener('DOMContentLoaded', function () {
  const videos = document.querySelectorAll('video-component video');

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const video = entry.target;
        if (video.paused) {
          video.play().catch(() => {});
        }
      } else {
        const video = entry.target;
        if (!video.paused) {
          video.pause();
        }
      }
    });
  }, {
    rootMargin: '200px 0px',
    threshold: 0.25
  });

  videos.forEach(video => {
    observer.observe(video);
  });
});

class UpsMarquee extends HTMLElement {
constructor() {
  super();
  this.animationSpeed = this.dataset.animationSpeed ? this.dataset.animationSpeed * 1000 : 20000;
  this.isAnimating = false;
  this.animationFrameId = null;
  this.lastTimestamp = 0;
  this.currentPosition = 0;
  this.singleSetWidth = 0;
  this.pixelsPerSecond = 0;
  this.infiniteContainer = null;
  this.intersectionObserver = null;
}

connectedCallback() {
  if (window.requestIdleCallback) {
    requestIdleCallback(() => this.observeAndInit());
  } else {
    setTimeout(() => this.observeAndInit(), 100);
  }
}

disconnectedCallback() {
  this.stopAnimation();
  this.intersectionObserver?.disconnect();
}

observeAndInit() {
  this.intersectionObserver = new IntersectionObserver(entries => {
    if (entries[0].isIntersecting) {
      this.initMarquee();
      this.intersectionObserver.disconnect();
    }
  }, { threshold: 0.1 });

  this.intersectionObserver.observe(this);
}

stopAnimation() {
  cancelAnimationFrame(this.animationFrameId);
  this.animationFrameId = null;
  this.isAnimating = false;
}

initMarquee() {
  const marqueeContainer = this.querySelector('.ups-mobile-marquee');
  const marqueeWrapper = this.querySelector('.marquee-wrapper');
  const slides = this.querySelectorAll('.ups-marquee-slide');

  if (!marqueeContainer || !marqueeWrapper || slides.length === 0) return;

  const infiniteContainer = document.createElement('div');
  infiniteContainer.style.cssText = `
    display: flex;
    width: fit-content;
    will-change: transform;
    transform: translate3d(0, 0, 0);
  `;

  slides.forEach(slide => infiniteContainer.appendChild(slide.cloneNode(true)));
  slides.forEach(slide => infiniteContainer.appendChild(slide.cloneNode(true)));
  slides.forEach(slide => infiniteContainer.appendChild(slide.cloneNode(true)));

  while (marqueeWrapper.firstChild) marqueeWrapper.removeChild(marqueeWrapper.firstChild);
  marqueeWrapper.appendChild(infiniteContainer);

  this.infiniteContainer = infiniteContainer;

  this.singleSetWidth = Array.from(infiniteContainer.children).slice(0, slides.length).reduce((acc, slide) => acc + slide.offsetWidth, 0);
  this.pixelsPerSecond = this.singleSetWidth / (this.animationSpeed / 1000);
  this.animationStartTime = performance.now();
  this.lastTimestamp = this.animationStartTime;
  this.isAnimating = true;

  this.animationFrameId = requestAnimationFrame(this.animate.bind(this));
}

animate(timestamp) {
  if (!this.isAnimating || !this.infiniteContainer) return;

  const elapsedTime = timestamp - this.animationStartTime;
  this.currentPosition = -(this.pixelsPerSecond * (elapsedTime / 1000)) % this.singleSetWidth;

  this.infiniteContainer.style.transform = `translate3d(${this.currentPosition}px, 0, 0)`;
  this.animationFrameId = requestAnimationFrame(this.animate.bind(this));
}
}

if (!window.customElements.get("ups-marquee")) {
window.customElements.define("ups-marquee", UpsMarquee);
}


class CsImageWithText extends HTMLElement {
constructor() {
  super();
  this.hasHoverImage = false;
  this.hasHoverClipmarks = false;
  this.widthHover = false;
  if(this.dataset.widthHover == "true") {
    this.widthHover = true;
  }
  this.buttons = this.querySelectorAll('.cs-button');
  if ( this.dataset.hasHoverImage == "true") {
    this.hasHoverImage = true;
  }
  if ( this.dataset.hasHoverClipmarks == "true") {
    this.hasHoverClipmarks = true;
  }
  this.imageWrappers = this.querySelectorAll('.cs-image-with-text-content-bg-image');
  this.clipmarks = this.querySelectorAll('.cs-clipmarks.on-hover');
}

connectedCallback() {
  if (this.widthHover == true) {
    this.setWidths();
  }

  this.buttons.forEach(button => {
      button.addEventListener('mouseenter', this.handleMouseEnter.bind(this));
    });

  this.buttons.forEach(button => {
    button.addEventListener('mouseleave', this.handleMouseLeave.bind(this));
  });
}

disconnectedCallback() {

}

setWidths() {
  this.buttons.forEach (button => {
    if(button.classList.contains('btn-small-width')) {
      let paddingWidth = 0;
      if(this.dataset.inSwiper == "true") {
        paddingWidth = 80;
      }
      let smallWidth = button.offsetWidth + 2 - paddingWidth;
      let fullWidth = button.closest('.text-content').offsetWidth - 64 - paddingWidth;
      button.style.width = smallWidth + 'px';
      button.dataset.smallWidth = smallWidth;
      button.dataset.fullWidth = fullWidth;
    }
  });
}

handleMouseEnter(event) {
  let button = event.currentTarget;
  if (this.widthHover == true) {
    button.style.width = button.dataset.fullWidth + 'px';
  }
  if (this.hasHoverImage == true) {
    this.showHoverImage();
  }
  if (this.hasHoverClipmarks == true) {
    this.showClipmarks();
  }
}

handleMouseLeave(event) {
  let button = event.currentTarget;
  if (this.widthHover == true) {
    button.style.width = button.dataset.smallWidth + 'px';
  }
  if (this.hasHoverImage == true) {
    this.hideHoverImage();
  }
  if (this.hasHoverClipmarks == true) {
    this.hideClipmarks();
  }
}

showHoverImage() {
  this.imageWrappers.forEach(wrapper => {
    wrapper.querySelector('.cs-image-with-text-content-bg-image-image').style.opacity = 0;
    wrapper.querySelector('.cs-image-with-text-content-bg-image-image-hover').style.opacity = 1;
  });
}

showClipmarks() {
  this.clipmarks.forEach(clipmark => {
    clipmark.style.opacity = 1;
  });
}

hideHoverImage() {
  this.imageWrappers.forEach(wrapper => {
    wrapper.querySelector('.cs-image-with-text-content-bg-image-image').style.opacity = 1;
    wrapper.querySelector('.cs-image-with-text-content-bg-image-image-hover').style.opacity = 0;
  });
}

hideClipmarks() {
  this.clipmarks.forEach(clipmark => {
    clipmark.style.opacity = 0;
  });
}
}

if (!window.customElements.get("cs-image-with-text-2")) {
window.customElements.define("cs-image-with-text-2", CsImageWithText );
}

class MiImageWithText extends HTMLElement {
constructor() {
  super();
  this.hasHoverImage = this.dataset.hasHoverImage === "true";
  this.hasHoverClipmarks = this.dataset.hasHoverClipmarks === "true";
  this.widthHover = this.dataset.widthHover === "true";
  this.inSwiper = this.dataset.inSwiper === "true";

  this.button = this.querySelector('.mi-button');
  this.imageWrapper = this.querySelector('.mi-image-with-text-media');
  this.clipmarks = this.querySelectorAll('.mi-clipmarks.on-hover');
}

connectedCallback() {
  if (this.widthHover && this.button) {
    this.setWidthsOnce();
    this.boundResize = this.setWidthsOnce.bind(this);
    window.addEventListener('resize', this.boundResize);
  }

  this.button?.addEventListener('mouseenter', this.onEnter.bind(this));
  this.button?.addEventListener('mouseleave', this.onLeave.bind(this));
}

disconnectedCallback() {
  if (this.boundResize) {
    window.removeEventListener('resize', this.boundResize);
  }
}

setWidthsOnce() {
  if (!this.button?.classList.contains('button-primary')) return;

  // solo recalcula si cambia el ancho disponible
  const textContent = this.button.closest('.text-content');
  if (!textContent) return;

  const paddingWidth = this.inSwiper ? 80 : 0;
  const fullWidth = textContent.offsetWidth - 64 - paddingWidth;
  const smallWidth = this.button.scrollWidth + 2 - paddingWidth;

  if (this.button.dataset.fullWidth != fullWidth || this.button.dataset.smallWidth != smallWidth) {
    this.button.dataset.fullWidth = fullWidth;
    this.button.dataset.smallWidth = smallWidth;
    this.button.style.width = smallWidth + 'px';
  }
}

onEnter(e) {
  if (this.widthHover) {
    this.button.style.width = this.button.dataset.fullWidth + 'px';
  }
  if (this.hasHoverImage) this.toggleHoverImage(true);
  if (this.hasHoverClipmarks) this.toggleClipmarks(true);
}

onLeave(e) {
  if (this.widthHover) {
    this.button.style.width = this.button.dataset.smallWidth + 'px';
  }
  if (this.hasHoverImage) this.toggleHoverImage(false);
  if (this.hasHoverClipmarks) this.toggleClipmarks(false);
}

toggleHoverImage(show) {
  if (!this.imageWrapper) return;
  const main = this.imageWrapper.querySelector('.mi-media');
  const hover = this.imageWrapper.querySelector('.hover-media');
  if (main && hover) {
    main.style.opacity = show ? 0 : 1;
    hover.style.opacity = show ? 1 : 0;
  }
}

toggleClipmarks(show) {
  this.clipmarks.forEach(c => c.style.opacity = show ? 1 : 0);
}
}

if (!window.customElements.get("mi-image-with-text")) {
window.customElements.define("mi-image-with-text", MiImageWithText);
}


class CollectionSlider extends HTMLElement {
constructor() {
  super();
  this.slidesPerView = this.dataset.slidesPerView;
  this.mobileSlidesPerView = this.dataset.mobileSlidesPerView;
  this.swiperContainer = this.querySelector('.swiper');
}

connectedCallback() {
  this.initSwiper();
}

disconnectedCallback() {

}

initSwiper() {
  this.swiper = new Swiper(this.swiperContainer, {
    slidesPerView: this.mobileSlidesPerView,
    spaceBetween: 16,
    autoHeight: true,
    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: true
    },
    breakpoints: {
      990: {
        slidesPerView: this.slidesPerView
      }
    }
  });
}
}

if (!window.customElements.get("collection-slider")) {
window.customElements.define("collection-slider", CollectionSlider );
}

class VideoComponent extends HTMLElement {
constructor() {
  super();
  this.muteUnmuteBtn = this.querySelector('.video-component-mute-unmute-button');
  this.video = this.querySelector('video');
  this.muted = true;
  this.desktopBtnElement = this.querySelector('.desktop-icon');
  this.mobileBtnElement = this.querySelector('.mobile-icon');
  this.desktopActiveText = "Sound On";
  this.desktopUnactiveText = "Sound Off"
  this.mobileActiveIcon = "<svg width='10' height='16' viewBox='0 0 10 16' fill='none' xmlns='http://www.w3.org/2000/svg'><path fill-rule='evenodd' clip-rule='evenodd' d='M4.958 11.576H.792a.78.78 0 0 1-.791-.764L0 5.19c0-.422.354-.765.791-.765h4.311L10 0v16l-4.897-4.424z' fill='#fff'/></svg>";
  this.mobileUnactiveIcon = "<svg width='15' height='16' viewBox='0 0 15 16' fill='none' xmlns='http://www.w3.org/2000/svg'><path fill-rule='evenodd' clip-rule='evenodd' d='M11.77 11.376.504 0 0 .51l3.88 3.917h-.91a.76.76 0 0 0-.756.764v5.621c0 .21.085.401.222.54 0 .042.271.224.534.224h4.119L11.769 16v-3.605l2.727 2.753.504-.509zM5.897 4.427H7.09L11.77.004v10.353z' fill='#fff'/></svg>";
  this.allVideoCompoonents = document.querySelectorAll('video-component');
}

connectedCallback() {
  this.muteUnmuteBtn?.addEventListener('click', this.handleMuteUnmute.bind(this));
}

disconnectedCallback() {
  this.muteUnmuteBtn?.removeEventListener('click', this.handleMuteUnmute);
}

handleMuteUnmute() {
  if (this.muted) {
    this.video.muted = false;
    this.muted = false;
    this.desktopBtnElement.innerHTML = this.desktopUnactiveText;
    this.mobileBtnElement.innerHTML = this.mobileUnactiveIcon;
    this.muteVideoComponents();
  } else {
    this.video.muted = true;
    this.muted = true;
    this.desktopBtnElement.innerHTML = this.desktopActiveText;
    this.mobileBtnElement.innerHTML = this.mobileActiveIcon;
  }
}

muteVideo() {
  this.video.muted = true;
  this.muted = true;
  this.desktopBtnElement.innerHTML = this.desktopActiveText;
  this.mobileBtnElement.innerHTML = this.mobileActiveIcon;
}

muteVideoComponents() {
  this.allVideoCompoonents.forEach(videoComponent => {
    if (videoComponent != this && videoComponent.muted == false) {
      videoComponent.muteVideo();
    }
  });
}
}

if (!window.customElements.get("video-component")) {
window.customElements.define("video-component", VideoComponent );
}

class CollectionTabs extends HTMLElement {
constructor() {
  super();
  this.tabs = this.querySelectorAll('.mi-collection-tab');
  this.tabColorEl = this.querySelector('.current-collection-color');
  this.visibleCollection = this.querySelector('.mi-collection-tab-products.active');
  this.currentColorScheme = this.tabColorEl?.dataset.currentColorScheme || '';
}

connectedCallback() {
  if (!this.tabs.length || !this.tabColorEl) return;

  this.tabs.forEach(tab => {
    tab.addEventListener('click', this.handleTabClick.bind(this));
    tab.addEventListener('mouseenter', this.handleTabMouseEnter.bind(this));
    tab.addEventListener('mouseleave', this.handleTabMouseLeave.bind(this));
  });
}

disconnectedCallback() {
  this.tabs.forEach(tab => {
    tab.removeEventListener('click', this.handleTabClick);
    tab.removeEventListener('mouseenter', this.handleTabMouseEnter);
    tab.removeEventListener('mouseleave', this.handleTabMouseLeave);
  });
}

handleTabMouseEnter(e) {
  const tab = e.currentTarget;
  const newScheme = tab.dataset.colorScheme;
  if (newScheme && this.currentColorScheme !== newScheme) {
    this.tabColorEl.classList.replace(this.currentColorScheme, newScheme);
  }
}

handleTabMouseLeave(e) {
  const tab = e.currentTarget;
  const oldScheme = tab.dataset.colorScheme;
  if (oldScheme && oldScheme !== this.currentColorScheme) {
    this.tabColorEl.classList.replace(oldScheme, this.currentColorScheme);
  }
}

handleTabClick(e) {
  e.preventDefault();
  const tab = e.currentTarget;

  this.tabs.forEach(t => t.classList.remove('active'));
  tab.classList.add('active');

  const newScheme = tab.dataset.colorScheme;
  if (newScheme && this.currentColorScheme !== newScheme) {
    this.tabColorEl.classList.replace(this.currentColorScheme, newScheme);
    this.currentColorScheme = newScheme;
  }

  this.switchCollection(tab.dataset.collectionId);
}

switchCollection(collectionId) {
  if (this.visibleCollection) this.visibleCollection.classList.remove('active');
  this.visibleCollection = this.querySelector(`.collection-${collectionId}`);
  this.visibleCollection?.classList.add('active');
}
}

if (!window.customElements.get("collection-tabs")) {
window.customElements.define("collection-tabs", CollectionTabs);
}

class ArticleCardContent extends HTMLElement {
constructor() {
  super();
  this.clipmarks = this.querySelectorAll('.article-card-clipmarks');
  this.button = this.querySelector('.article-card-button');
  this.infoBox = this.querySelector('.card__information');
  this.fullWidth = 0;
  this.smallWidth = 0;
  this.resizeObserver = null;
}

connectedCallback() {
  if (!this.button || !this.infoBox) return;

  this.setWidths();
  this.resizeObserver = new ResizeObserver(() => this.setWidths());
  this.resizeObserver.observe(this.infoBox);

  this.button.addEventListener('mouseenter', this.handleMouseEnter.bind(this));
  this.button.addEventListener('mouseleave', this.handleMouseLeave.bind(this));
}

disconnectedCallback() {
  this.button?.removeEventListener('mouseenter', this.handleMouseEnter);
  this.button?.removeEventListener('mouseleave', this.handleMouseLeave);
  this.resizeObserver?.disconnect();
}

setWidths() {
  const newFull = this.infoBox.offsetWidth - 32;
  const newSmall = this.button.scrollWidth + 1;

  if (newFull !== this.fullWidth || newSmall !== this.smallWidth) {
    this.fullWidth = newFull;
    this.smallWidth = newSmall;
    this.button.style.width = `${this.smallWidth}px`;
  }
}

handleMouseEnter(e) {
  e.preventDefault();
  this.clipmarks.forEach(c => (c.style.opacity = 1));
  this.button.style.width = `${this.fullWidth}px`;
}

handleMouseLeave(e) {
  e.preventDefault();
  this.clipmarks.forEach(c => (c.style.opacity = 0));
  this.button.style.width = `${this.smallWidth}px`;
}
}

if (!window.customElements.get("article-card-content")) {
window.customElements.define("article-card-content", ArticleCardContent);
}
class UspSwiper extends HTMLElement {
constructor() {
  super();
  this.mobileSwiper = this.dataset.mobileSwiper === 'true';
  this.autoplay = this.dataset.autoplay === 'true';
  this.speed = parseInt(this.dataset.speed || 20) * 1000;
  this.marqueeAnimation = null;
  this.infiniteContainer = null;
}

connectedCallback() {
  if (this.mobileSwiper && this.autoplay) {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(() => this.observeAndInitMarquee());
    } else {
      setTimeout(() => this.observeAndInitMarquee(), 100);
    }
  } else {
    this.initSwiper();
  }
}

disconnectedCallback() {
  if (this.marqueeAnimation) cancelAnimationFrame(this.marqueeAnimation);
  this.observer?.disconnect();
}

observeAndInitMarquee() {
  this.observer = new IntersectionObserver(entries => {
    if (entries[0].isIntersecting) {
      this.initMarquee();
      this.observer.disconnect();
    }
  }, { threshold: 0.1 });

  this.observer.observe(this);
}

initMarquee() {
  const container = this.querySelector('.ups-swiper-mobile');
  const wrapper = this.querySelector('.swiper-wrapper');
  const slides = this.querySelectorAll('.ups-swiper-slide');

  if (!container || !wrapper || slides.length === 0) return;

  this.infiniteContainer = document.createElement('div');
  this.infiniteContainer.style.cssText = 'display:flex;width:fit-content;will-change:transform;';

  for (let i = 0; i < 3; i++) {
    slides.forEach(slide => {
      const clone = slide.cloneNode(true);
      this.infiniteContainer.appendChild(clone);
    });
  }

  wrapper.innerHTML = '';
  wrapper.appendChild(this.infiniteContainer);

  container.style.overflow = 'hidden';
  wrapper.style.willChange = 'transform';

  const singleSetWidth = Array.from(slides).reduce((acc, s) => acc + s.offsetWidth, 0);
  let currentPosition = 0;
  const pixelsPerSecond = singleSetWidth / (this.speed / 1000);
  let lastTime = 0;

  const animate = (now) => {
    if (!lastTime) lastTime = now;
    const delta = now - lastTime;
    currentPosition -= pixelsPerSecond * (delta / 1000);
    if (currentPosition <= -singleSetWidth) currentPosition = 0;

    this.infiniteContainer.style.transform = `translateX(${currentPosition}px)`;
    lastTime = now;
    this.marqueeAnimation = requestAnimationFrame(animate);
  };

  requestAnimationFrame(animate);
}

initSwiper() {
  if (typeof Swiper === 'undefined') return;

  const el = this.querySelector(this.mobileSwiper ? '.ups-swiper-mobile' : '.ups-swiper');
  if (!el) return;

  const config = {
    slidesPerView: this.mobileSwiper ? 1.05 : 4,
    spaceBetween: this.mobileSwiper ? 2 : 4,
    freeMode: true,
    autoHeight: true,
    scrollbar: this.mobileSwiper ? undefined : {
      el: '.swiper-scrollbar.ups-scrollbar',
      draggable: true,
    },
  };

  new Swiper(el, config);

  if (this.mobileSwiper) {
    const wrapper = this.querySelector('.swiper-wrapper');
    if (wrapper) {
      const heights = Array.from(this.querySelectorAll('.ups-swiper-slide')).map(s => s.querySelector('.ups-swiper-slide-content')?.offsetHeight || 0);
      const maxHeight = Math.max(...heights);
      wrapper.style.height = `${maxHeight}px`;
      this.querySelectorAll('.ups-swiper-slide').forEach(s => s.style.height = `${maxHeight}px`);
      el.classList.add('custom-autoheiht-swiper');
    }
  }
}
}

if (!window.customElements.get("usp-swiper")) {
window.customElements.define("usp-swiper", UspSwiper);
}

  
class MiTestimonialsSwiper extends HTMLElement {
  constructor() {
    super();
    this.slidesPerView = this.dataset.desktopPerView * 1;
    this.mobileLayout = this.dataset.mobileLayout;
  }

  connectedCallback() {
    this.initSwiper();
    window.addEventListener('resize', this.reInitSwiper.bind(this));
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.reInitSwiper);
  }

  initSwiper() {
    const slidesPerView = this.slidesPerView;
    if (this.mobileLayout === 'stacked') {
      console.log('mobileLayout is stacked! Swiper should be disabled on mobile!');
      this.swiper = new Swiper('.mi-testimonials-swiper', {
        enabled: false,
        breakpoints: {
          990: {
            enabled: true,
            slidesPerView: slidesPerView,
            spaceBetween: 80,
            autoHeight: true,
            scrollbar: {
              el: '.swiper-scrollbar.testimonials-scrollbar',
              draggable: true,
            },
          }
        }
      });
    }
    else {
      this.swiper = new Swiper('.mi-testimonials-swiper', {
        slidesPerView: 1.05,
        spaceBetween: 40,
        autoHeight: true,
        pagination: {
          el: '.swiper-pagination.testimonials-pagination',
          clickable: true,
        },
        breakpoints: {
          990: {
            slidesPerView: slidesPerView,
            spaceBetween: 80,
            scrollbar: {
              el: '.swiper-scrollbar.testimonials-scrollbar',
              draggable: true,
            },
            pagination: false,
          },
        }
      });
    }
  }

  reInitSwiper() {
    this.swiper.destroy(true, true);
    this.initSwiper();
  }
}

if (!window.customElements.get("mi-testimonials-swiper")) {
  window.customElements.define("mi-testimonials-swiper", MiTestimonialsSwiper );
}

class MiBeforeAfterSwiper extends HTMLElement {
constructor() {
  super();
  this.slidesPerView = Number(this.dataset.desktopPerView || 1);
  this.mobileLayout = this.dataset.mobileLayout;
  this.swiper = null;
}

connectedCallback() {
  if (typeof Swiper === 'undefined') return;

  this.initSwiper();
  this.boundResize = this.reInitSwiper.bind(this);
  window.addEventListener('resize', this.boundResize);
}

disconnectedCallback() {
  window.removeEventListener('resize', this.boundResize);
  this.swiper?.destroy(true, true);
}

initSwiper() {
  const el = this.querySelector('.mi-before-after-blocks-swiper');
  if (!el) return;

  const isStacked = this.mobileLayout === 'stacked';

  this.swiper = new Swiper(el, {
    enabled: !isStacked,
    slidesPerView: isStacked ? 1.1 : this.slidesPerView,
    spaceBetween: isStacked ? 44 : 80,
    autoHeight: true,
    breakpoints: {
      990: {
        enabled: true,
        slidesPerView: this.slidesPerView,
        spaceBetween: 80,
        autoHeight: true,
        scrollbar: {
          el: '.swiper-scrollbar.mi-before-after-blocks-scrollbar',
          draggable: true,
        },
      },
    },
  });
}

reInitSwiper() {
  if (!this.swiper) return;
  this.swiper.destroy(true, true);
  this.initSwiper();
}
}

if (!window.customElements.get("mi-before-after-swiper")) {
window.customElements.define("mi-before-after-swiper", MiBeforeAfterSwiper);
}
